module.exports = __webpack_public_path__ + "static/media/contact-image2.64725a66.jpg";